import { Button, ButtonVariant, Intent, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { GRADIENT_TYPE } from "src/libs/utilities/colors"


const GradientType = (props: any) : JSX.Element => {

    const onClick = () => {
        props.onClick()
    }
    return <Tooltip
        position="top"
        intent={Intent.PRIMARY}
        hoverOpenDelay={1000}
        content={<div className="px-1 smaller letter-spacing-1" >
            {__(props.type === GRADIENT_TYPE.LINEAR ? "Linear gradient" : "Radial gradient")}
        </div>}
    >
        <Button 
            variant={ButtonVariant.MINIMAL} 
            className='p-2 mx-0'  
            onClick={onClick} 
        >
            <svg 
                version="1.1"
                xmlns="http://www.w3.org/2000/svg" 
                x="0px" y="0px"
                viewBox="0 0 223.8 222.2"
                width={26}
                height={26}
            > 
            {
                props.type === GRADIENT_TYPE.LINEAR
                    ?
                    <>
                        <path d="M59.4,205.8L59.4,205.8c-16.2,0-29.4-13.2-29.4-29.4V41.8c0-16.2,13.2-29.4,29.4-29.4h0c16.2,0,29.4,13.2,29.4,29.4v134.6C88.8,192.7,75.6,205.8,59.4,205.8z"/>
                        <path d="M132.1,205.8L132.1,205.8c-9.6,0-17.3-7.7-17.3-17.3V29.8c0-9.6,7.7-17.3,17.3-17.3h0c9.6,0,17.3,7.7,17.3,17.3v158.8C149.4,198.1,141.7,205.8,132.1,205.8z"/>
                        <path d="M185.4,205.8L185.4,205.8c-3.7,0-6.6-3-6.6-6.6V19.1c0-3.7,3-6.6,6.6-6.6l0,0c3.7,0,6.6,3,6.6,6.6v180.1C192,202.9,189.1,205.8,185.4,205.8z"/>
                    </> 
                    :
                    <>
                        <path d="M110.4,206.5c-51.6,0-93.5-42-93.5-93.5s42-93.5,93.5-93.5c51.6,0,93.5,42,93.5,93.5S161.9,206.5,110.4,206.5z M110.4,59.4c-29.5,0-53.5,24-53.5,53.5s24,53.5,53.5,53.5s53.5-24,53.5-53.5S139.9,59.4,110.4,59.4z"/>
                        <path d="M110.4,160.5c-26.2,0-47.5-21.3-47.5-47.5c0-26.2,21.3-47.5,47.5-47.5s47.5,21.3,47.5,47.5C157.9,139.2,136.5,160.5,110.4,160.5z M110.4,81.5C93,81.5,78.9,95.6,78.9,113s14.1,31.5,31.5,31.5s31.5-14.1,31.5-31.5S127.7,81.5,110.4,81.5z"/>
                        <path d="M110.4,136.1c-12.7,0-23.1-10.4-23.1-23.1c0-12.7,10.4-23.1,23.1-23.1s23.1,10.4,23.1,23.1C133.4,125.7,123.1,136.1,110.4,136.1z M110.4,95.9c-9.4,0-17.1,7.7-17.1,17.1s7.7,17.1,17.1,17.1s17.1-7.7,17.1-17.1S119.8,95.9,110.4,95.9z"/>
                    </>      
            }
            </svg>
        </Button>
    </Tooltip>
}

export default GradientType